import React from "react";
import {
  ThemeProvider,
  StylesProvider,
  createGenerateClassName,
} from "@mui/styles";
import { darkTheme } from "../theme";

const generateClassName = createGenerateClassName({
  seed: "recode",
  productionPrefix: "rc",
});

type Props = { children: React.ReactNode };

/**
 * MUI theme + JSS insertion order. Mount only under layouts/routes that import @mui/*.
 * Default export supports React.lazy code-splitting for marketing (e.g. WebsiteLayout /jobs).
 */
export default function MuiProviders({ children }: Props) {
  return (
    <StylesProvider generateClassName={generateClassName} injectFirst>
      <ThemeProvider theme={darkTheme}>{children}</ThemeProvider>
    </StylesProvider>
  );
}
